import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'

@Injectable()
export class FinancialInstitutionsService {
  constructor(private http: HttpClient) {}

  public fetchFinancialInstitutions(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/financialInstitution/list`
    return this.http.post(url, params)
  }
  public fetchFinancialInstitution(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/financialInstitution/${id}`
    return this.http.get(url, {})
  }

  public deleteFinancialInstitution(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/financialInstitution/${id}`
    return this.http.delete(url)
  }

  public createFinancialInstitution(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/financialInstitution`
    return this.http.post(url, params)
  }

  public updateFinancialInstitution(
    id: number,
    params: object,
  ): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/financialInstitution/${id}`
    return this.http.put(url, params)
  }
}
